import React, { useEffect, useState } from "react";
import SideBar from "../components/SideBar";
import BackButton from "../components/Base/BackButton";
import { useMediaQuery } from "react-responsive";
import { Notification, success } from "../components/Notification/index";
import { Components } from "../assets/Dimensions";

import {
  getMemberByEmail,
  updateCreditStatus,
  addNewCredit,
  clearUserCache,
  addNewCreditBulk,
  getAllUserEmail,
  resetUserPassword,
  creditAccordingToDate,
  refundCredit,
} from "../api/User";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import "./Credits.css";
import Loader from "../components/Loader";
import { toast } from "react-toastify";
import { enumToOptions } from "../helpers/enumToOptions";
import LoginTypes from "../enums/LoginType";
import ResponseStatus from "../util/enums";
import { getCreditTypeLabel } from "../enums/CreditResourceType";

import CreditsHeader from "../components/CreditsPanel/CreditsHeader/CreditsHeader";
import UserSearchCard from "../components/CreditsPanel/UserSearchCard/UserSearchCard";
import UserEmailTable from "../components/CreditsPanel/UserEmailTable/UserEmailTable";
import CreditTable from "../components/CreditsPanel/CreditTable/CreditTable";
import CreditOperations from "../components/CreditsPanel/CreditOperations/CreditOperations";
import ConfirmDialog from "../components/CreditsPanel/ConfirmDialog/ConfirmDialog";
import RefundResultDialog from "../components/CreditsPanel/RefundResultDialog/RefundResultDialog";

function CreditsPage() {
  const [email, setEmail] = useState("");
  const [userId, setUserId] = useState();
  const [enddate, setEndDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [codeLength, setCodeLenght] = useState("");
  const [enddateBulk, setEndDateBulk] = useState("");
  const [startDateBulk, setStartDateBulk] = useState("");
  const [count, setCount] = useState("");
  const [promationName, setPromationName] = useState("");
  const [notFound, setNotFound] = useState("");
  const [bulkCredit, setBulkCredit] = useState([]);
  const [value, setValue] = useState("1");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [nav, setNav] = useState(false);
  const [emailData, setEmailData] = useState([]);
  const [displayCreditData, setCreditData] = useState(false);
  const [displayUserEmailData, setUserEmailData] = useState(false);
  const [price, setPrice] = useState();
  const [startDateForBill, setStartDateForBill] = useState("");
  const [endDateForBill, setEndDateForBill] = useState("");
  const [paidUsers, setPaidUsers] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [refundModal, setRefundModal] = useState(false);
  const [refundTarget, setRefundTarget] = useState(null);
  const [refundResultModal, setRefundResultModal] = useState(false);
  const [refundResultMessage, setRefundResultMessage] = useState("");
  const [refundCustomerMessage, setRefundCustomerMessage] = useState("");
  const [refundResultSuccess, setRefundResultSuccess] = useState(false);
  const [selectedLoginType, setSelectedLoginType] = useState(LoginTypes.PhoneNumber);
  const _user = JSON.parse(localStorage.getItem("user"));

  const pJWT = sessionStorage.getItem("jwtP");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 700px)" });

  const getData = async (mail) => {
    setPaidUsers(null);
    setLoading(true);
    try {
      const res = await getMemberByEmail(mail ? mail : email, selectedLoginType, pJWT, true);
      const Error = await res.response;
      setLoading();
      if (res.status == 200 && res.data.ResponseStatus == ResponseStatus.Success) {
        setData(res.data.ResponseData);
      }
      if (Error.status == 400) {
        setNotFound(Error.data.Error);
      } else {
        toast.error("Lütfen Tekrar Giriş Yapınız");
      }
    } catch (error) {}
  };

  const userAllEmail = async () => {
    setPaidUsers(null);
    setLoading(true);
    try {
      const res = await getAllUserEmail(email, selectedLoginType, pJWT);
      const Error = await res.response;
      setLoading();
      if (res.data.ResponseStatus == 1) {
        setEmailData(res.data.ResponseData);
      } else if (Error.status == 400) {
        setNotFound(Error.data.Error);
      } else {
        toast.error("Lütfen Tekrar Giriş Yapınız");
      }
    } catch (error) {}
  };

  const resetPassword = async (email) => {
    setPaidUsers(null);
    setLoading(true);
    const res = await resetUserPassword(email, pJWT);
    console.log("resReset", res);
    if (res.status == 200) {
      toast.success("Şifre sıfırlama başarılı");
    } else if (res.status == 400) {
      toast.error("kullanıcı bulunamadı");
    } else {
      toast.error("Lütfen Tekrar Giriş Yapınız");
    }
  };

  const formatDate = (date) => {
    if (!date) return "";

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  const paymentCheck = async (startDate, endDate, price) => {
    const payLoad = {
      StartDate: formatDate(startDate),
      EndDate: formatDate(endDate),
      Value: parseInt(price, 10),
    };
    const res = await creditAccordingToDate(payLoad, pJWT);
    if (res.data.ResponseStatus == 1) {
      console.log("istek başarılı", res.data.ResponseData);
      setPaidUsers(res.data.ResponseData);
    }
  };

  useEffect(() => {
    if (data.length > 0) {
      setUserId(data[0].UserId);
    }
  }, [data]);

  const updateStatus = async (credit) => {
    setPaidUsers(null);
    setLoading(true);
    const res = await updateCreditStatus(credit.Id, pJWT, true);
    success("Stutus Updated");
    setLoading();
    getData();
  };

  const reRender = async (email) => {
    setPaidUsers(null);
    console.log("mail", email);
    setPaidUsers(null);
    setData([]);
    setNotFound("");
    await getData(email);
    setCreditData(true);
  };

  const clearCahce = async () => {
    setPaidUsers(null);
    setLoading(true);
    const res = await clearUserCache(userId, pJWT, true);
    if (res.status == 200) {
      success("Cache Cleared");
    }
    setLoading();
  };

  const getallEmailsOfUser = () => {
    setPaidUsers(null);
    setLoading(true);
    userAllEmail();
    setCreditData(false);
    setUserEmailData(true);
  };

  const addCredit = async () => {
    setPaidUsers(null);
    const params = {
      UserName: email,
      EndDate: moment(enddate).add("26", "hours").add("59", "minute"),
      StartDate: moment(startDate).add("3", "hours"),
      LoginType: selectedLoginType,
    };

    setLoading(true);
    const res = await addNewCredit(params, pJWT, true);
    if (res.status == 200) success("Yeni Credi Eklendi");
    setLoading();
  };

  const addCreditBulk = async () => {
    setPaidUsers(null);
    const params = {
      CodeLength: codeLength,
      Count: value,
      EndDate: moment(enddateBulk).add("26", "hours").add("59", "minute"),
      StartDate: moment(startDateBulk).add("3", "hours"),
      PromotionName: promationName,
    };

    setLoading(true);
    const res = await addNewCreditBulk(params, pJWT, true);

    if (res.status == 200) {
      success("Bulk Credit Eklendi");
      setBulkCredit(res.data);
    }
    setLoading();
  };

  const min = 1;
  const max = 10;
  const handleChange = (event) => {
    const value = Math.max(min, Math.min(max, Number(event.target.value)));
    setValue(value);
  };

  const onCountChange = (event) => {
    handleChange(event);
    setCount(event.currentTarget.value);
  };

  const handleConfirmModal = () => {
    setConfirmModal(true);
  };

  const handleRefundModal = (credit) => {
    setRefundTarget(credit);
    setRefundModal(true);
  };

  // audience: "internal" (full detail) | "customer" (no Kullanıcı ID / Kredi ID)
  const buildRefundMessage = (credit, isSuccess, detail, audience = "internal") => {
    const identifierLabel = selectedLoginType == LoginTypes.PhoneNumber ? "Telefon" : "E-posta";
    const isInternal = audience === "internal";
    const lines = [isSuccess ? "İade işlemi BAŞARILI" : "İade işlemi BAŞARISIZ"];
    if (isInternal) lines.push(`Kullanıcı ID: ${credit.UserId}`);
    lines.push(`${identifierLabel}: ${email || "-"}`);
    if (isInternal) lines.push(`Kredi ID: ${credit.Id}`);
    lines.push(
      `Kredi Tipi (CreditResourceType): ${credit.CreditResourceType} (${getCreditTypeLabel(credit.CreditResourceType)})`
    );
    lines.push(`Tarih: ${moment().format("DD/MM/YYYY HH:mm")}`);
    if (detail) lines.push(`Açıklama: ${detail}`);
    return lines.join("\n");
  };

  const doRefund = async () => {
    if (!refundTarget) return;
    const target = refundTarget;
    setPaidUsers(null);
    setLoading(true);
    try {
      const res = await refundCredit(target.UserId, target.Id, pJWT, true);
      const isSuccess = res.status == 200 && res.data.ResponseStatus == ResponseStatus.Success;
      const detail = isSuccess
        ? res.data && res.data.ResponseMessage
        : (res.data && res.data.ResponseMessage) || "İade işlemi başarısız";
      setRefundResultSuccess(isSuccess);
      setRefundResultMessage(buildRefundMessage(target, isSuccess, detail, "internal"));
      setRefundCustomerMessage(buildRefundMessage(target, isSuccess, detail, "customer"));
      setRefundResultModal(true);
      if (isSuccess) await getData();
    } catch (err) {
      const detail = "İade işlemi sırasında beklenmeyen bir hata oluştu";
      setRefundResultSuccess(false);
      setRefundResultMessage(buildRefundMessage(target, false, detail, "internal"));
      setRefundCustomerMessage(buildRefundMessage(target, false, detail, "customer"));
      setRefundResultModal(true);
    }
    setLoading();
  };

  const copyToClipboard = (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(() => toast.success("Mesaj kopyalandı"))
        .catch(() => toast.error("Kopyalama başarısız"));
    } else {
      toast.error("Kopyalama bu tarayıcıda desteklenmiyor");
    }
  };

  const addCoachingToUser = async (email) => {
    const params = {
      UserName: email,
      ProductGroupId: 1,
      LoginType: selectedLoginType,
    };
    if (email.length > 0) {
      const res = await addNewCredit(params, pJWT, true);
      if (res.data.ResponseStatus == 1) {
        toast.success("Kullanıcıya koçluk başarıyla eklenmiştir eklenmiştir");
      } else {
        toast.error("Bir hata oluştu");
      }
    } else {
      toast.error("Lütfen Email giriniz");
    }
  };

  const options = enumToOptions(LoginTypes);

  const handleValueChange = (newValue) => {
    console.log("Selected Value:", newValue);
    setSelectedLoginType(newValue);
  };

  const getCredits = () => {
    reRender();
    setUserEmailData(false);
  };

  return (
    <div>
      {isTabletOrMobile ? (
        <div>
          <span className="credits-mobile-menu" onClick={() => setNav(!nav)}>
            menu
          </span>
          {nav && <SideBar />}
        </div>
      ) : (
        <SideBar />
      )}

      <ConfirmDialog
        open={confirmModal}
        title="Koçluk Tanımla"
        message="Bu kullanıcıya koçluk tanımlamayı onaylıyor musunuz?"
        confirmLabel="Tanımla"
        cancelLabel="Vazgeç"
        tone="primary"
        onConfirm={() => {
          addCoachingToUser(email);
          setConfirmModal(false);
        }}
        onClose={() => setConfirmModal(false)}
      />

      <ConfirmDialog
        open={refundModal}
        title="Krediyi İade Et"
        message={
          refundTarget
            ? `Bu krediyi (ID: ${refundTarget.Id}) iade etmek istediğinize emin misiniz?`
            : ""
        }
        confirmLabel="İade Et"
        cancelLabel="Vazgeç"
        tone="danger"
        onConfirm={() => {
          doRefund();
          setRefundModal(false);
        }}
        onClose={() => setRefundModal(false)}
      />

      <RefundResultDialog
        open={refundResultModal}
        success={refundResultSuccess}
        customerMessage={refundCustomerMessage}
        internalMessage={refundResultMessage}
        onCopyCustomer={() => copyToClipboard(refundCustomerMessage)}
        onCopyInternal={() => copyToClipboard(refundResultMessage)}
        onClose={() => setRefundResultModal(false)}
      />

      <div
        className="credits-page"
        style={{ paddingLeft: isTabletOrMobile ? 15 : Components.SideBarWidth + 15 }}
      >
        <div className="credits-page-container">
          <BackButton />
          <CreditsHeader
            title="Kredi Yönetimi"
            subtitle="Kullanıcı kredilerini görüntüleyin, yönetin ve Iyzico satın alımlarını iade edin."
          />

          <div className="credits-section">
            <div className="credits-card">
              <UserSearchCard
                options={options}
                initialLoginType={LoginTypes.PhoneNumber}
                loginType={selectedLoginType}
                onLoginTypeChange={handleValueChange}
                email={email}
                onEmailChange={setEmail}
                onSearchEnter={getCredits}
                onGetCredits={getCredits}
                onClearCache={clearCahce}
                onGetAllEmails={getallEmailsOfUser}
                onAddCoaching={handleConfirmModal}
              />
            </div>
          </div>

          {displayUserEmailData && (
            <div className="credits-section">
              <h3 className="credits-section-title">Kullanıcı E-postaları</h3>
              <div className="credits-card">
                <UserEmailTable
                  emailData={emailData}
                  selectedEmail={email}
                  displayCreditData={displayCreditData}
                  creditData={data}
                  loading={loading}
                  onGetCredit={(mail) => {
                    setEmail(mail);
                    reRender(mail);
                  }}
                  onResetPassword={resetPassword}
                  onUpdateStatus={updateStatus}
                  onRefund={handleRefundModal}
                />
              </div>
            </div>
          )}

          {displayCreditData && !displayUserEmailData && (
            <div className="credits-section">
              <h3 className="credits-section-title">Kredi Listesi</h3>
              <div className="credits-card">
                <CreditTable
                  data={data}
                  loading={loading}
                  onUpdateStatus={updateStatus}
                  onRefund={handleRefundModal}
                  emptyText={notFound || "Kredi bulunamadı."}
                />
              </div>
            </div>
          )}

          <div className="credits-section">
            <h3 className="credits-section-title">Kredi İşlemleri</h3>
            <div className="credits-card">
              <CreditOperations
                startDate={startDate}
                setStartDate={setStartDate}
                enddate={enddate}
                setEndDate={setEndDate}
                onAddCredit={addCredit}
                codeLength={codeLength}
                setCodeLength={setCodeLenght}
                count={value}
                onCountChange={onCountChange}
                promotionName={promationName}
                setPromotionName={setPromationName}
                startDateBulk={startDateBulk}
                setStartDateBulk={setStartDateBulk}
                enddateBulk={enddateBulk}
                setEndDateBulk={setEndDateBulk}
                onAddCreditBulk={addCreditBulk}
                bulkCredit={bulkCredit}
                startDateForBill={startDateForBill}
                setStartDateForBill={setStartDateForBill}
                endDateForBill={endDateForBill}
                setEndDateForBill={setEndDateForBill}
                price={price}
                setPrice={setPrice}
                onCheckPayment={() => paymentCheck(startDateForBill, endDateForBill, price)}
                paidUsers={paidUsers}
                isTablet={isTabletOrMobile}
              />
            </div>
          </div>
        </div>
      </div>

      {loading ? <Loader></Loader> : <></>}
      <Notification />
    </div>
  );
}

export default CreditsPage;
